import * as React from "react";
import { Form, Input, Row, Col } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import IconButton from "../ui/IconButton";
import FormHeader from "./FormHeader";
import { EquityPlaceholderName } from "../../types/newLinkBuilder";

interface IProps {
    formula: string,
    formulaLocation: string,
    setFormulaLocation: (value: string) => void,
    handlePlaceholder: (name: string) => void
}

const FormulaBuilderForm: React.FC<IProps> = ({ formula, formulaLocation, setFormulaLocation, handlePlaceholder }) => {
    return (
        <div>
            <FormHeader title="Formula Builder" />
            <Form.Item
                name={"formulaLocation"}
            >
                <Row
                    align={"middle"}

                >
                    <Col span={6} style={{ display: 'flex', justifyContent: 'start' }}>
                        <label htmlFor="formulaLocation">
                            Formula Location
                        </label>
                    </Col>

                    <Col span={16} style={{ display: 'flex', justifyContent: 'start' }}>
                        <Input
                            placeholder="A1"
                            id="formulaLocation"
                            value={formulaLocation}
                            onChange={(e) => setFormulaLocation(e.target.value)}
                        />
                    </Col>

                    <Col span={2} style={{ display: 'flex', justifyContent: 'end' }}>
                        <IconButton
                            icon={<UploadOutlined />}
                            onClick={() => handlePlaceholder(EquityPlaceholderName.FormulaLocationCellReference)}
                        />
                    </Col>
                </Row>
            </Form.Item>

            <Form.Item
                name={"formulaBuilder"}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    textAlign: 'left',
                    gap: '20px',
                    marginBlock: '20px',
                }}
            >
                <span>
                    Formula Builder:
                </span>

                <code
                    style={{
                        display: 'block',
                        padding: '20px',
                        backgroundColor: '#ffffff',
                        margin: 0,
                    }}
                >
                    {formula}
                </code>
            </Form.Item>
        </div>
    )
}

export default FormulaBuilderForm; 